import { StateSchema } from 'app/config/storeConfig/types';
import { Socket } from 'socket.io-client';

export const getSocketConnection = (state: StateSchema): Nullable<Socket> => state.socketConnection.socketConnection;
